import ApiClient, { IApiClient } from './ApiClient';
import { loginWithRedirect } from './auth/auth';

export function getApiClient(): IApiClient {
    if (!process.env.REACT_APP_API_URL) throw new Error('Missing API URL config');
    return new ApiClient(process.env.REACT_APP_API_URL, () => loginWithRedirect());
}
